import {ProjectTopCreatorsResource} from 'common/report/model-resources/project-top-creators';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<ProjectTopCreatorsResource>();

export const ProjectTopCreatorsProvider = context.Provider;
export const ProjectTopCreatorsConsumer = context.Consumer;
export const useProjectTopCreators = createRootContextHook(`projectTopCreators`);
